import { Toaster } from "sonner";
import { ReactNode } from "react";

interface ToasterProviderProps {
  children: ReactNode;
}

export function ToasterProvider({ children }: ToasterProviderProps) {
  return (
    <>
      {children}
      <Toaster position="top-center" richColors closeButton duration={4000} />
    </>
  );
}
